var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showing)?_c('div',{staticClass:"modal"},[_c('div',{staticClass:"modal__wrap",class:_vm.size},[_vm._t("body")],2)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }